/**
 * 出勤区分設定ページ用のスクリプト
 */
 if (is_route('instruction.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        instruction_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.instruction_event_set = function() {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id'], true, function() {
            // 初期セット
            $('#instruction-setting-modal input[name="display_types[]"]').trigger('change');
        });
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

    /*---- 印刷時 ----*/
    $(document).on('click', '[data-total-print]', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('total-print'));
        // 検索フォームを配列化
        let datas = $('#search-form').serializeArray();
        // BlobでPDFを別ウィンドウで表示
        _ajax.blob(action, datas, function (blob) {
            window.open(window.URL.createObjectURL(blob), '_blank');
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

    /*---- 設定モーダル 表示区分による点呼区分の表示非表示 ----*/
    $(document).on('change', 'input[name="display_types[]"]', function () {
        // 点呼簿チェック有
        if ($('#instruction-setting-modal-display_types_1:checked').length > 0) {
            $('.rollcall-contents').removeClass('d-none');
        } else {
            $('.rollcall-contents').addClass('d-none');
        }
    });
    /*---- CSVダウンロード時 ----*/

    // CSVダウンロード時
    $(document).on('click', '#search-form-action_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 検索フォームを配列化
        let datas = $('#search-form').serializeArray();
        // ポスト送信を実行
        post(action, datas);
    });

    /*---- CSVアップロード表示時 ----*/

    // CSVアップロード表示時
    $(document).on('click', '#search-form-action_upload', function () {
        // 初期化処理
        let modalId = '#instruction-csv-setting-modal';
        $(modalId + '-csv-submit-message').empty().addClass('display-none');
        $(modalId + '-csv-error').empty().addClass('display-none');
        $(modalId + '-csv_file_name').val('');
        $(modalId + '-csv').val('');
    });

    /*---- CSVアップロード画面の選択肢変更時 ----*/

    $(document).on('change', '#instruction-csv-setting-modal-holding_id', function () {
        // 既にCSV選択後であれば初期化処理
        if (!$('[data-csv-save-modal]').prop('disabled')) {
            let modalId = '#instruction-csv-setting-modal';
            $(modalId + '-csv-submit-message').empty().addClass('display-none');
            $(modalId + '-csv-error').empty().addClass('display-none');
            $(modalId + '-csv_file_name').val('');
            $(modalId + '-csv').val('');
            $(modalId + '-data_path').val('');
            $('[data-csv-save-modal]').prop('disabled', true);
        }
    });

    /*---- CSVアップロード確認時 ----*/

    // CSVアップロード確認時
    $(document).on('change', '#instruction-csv-setting-modal-csv', function () {
        let modalId = '#instruction-csv-setting-modal';
        let formId = '#instruction-csv-setting-modal-form';
        let action = $(formId).data('confirm-action');
        let datas = new FormData($(formId).get(0));
        $(modalId + '-csv-error').addClass('display-none');
        $(modalId + '-csv-error').empty();
        $(modalId + '-csv-submit-message').addClass('display-none');
        $(modalId + '-csv-submit-message').empty();
        $("[data-csv-save-modal]").prop("disabled", true);
        // 送信
        _ajax.file(action, datas, function (results) {
            $(modalId + '-csv-submit-message').removeClass('display-none');
            $(modalId + '-csv-submit-message').text(results.messages[0]);
            $("[data-csv-save-modal]").prop("disabled", false);
            $(modalId + '-data_path').val(results.data_path);
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
            $(this).val('');
            // フォームにエラーメッセージを配置
            $.each(xhr.responseJSON.errors, function(name, message) {
                $(modalId + '-csv-error').removeClass('display-none');
                $(modalId + '-csv-error').append($('<li></li>').text(message));
                $(modalId + '-csv_file_name').val('');
                $(modalId + '-csv').val('');
                $(modalId + '-data_path').val('');
            });
        });
    });

    /*---- CSVアップロード時 ----*/

    // 設定表示時
    $(document).on('click', '[data-csv-save-modal]', function () {
        let modalId = '#instruction-csv-setting-modal';
        let formId = '#instruction-csv-setting-modal-form';
        let action = $(formId).attr('action');
        let datas = new FormData($(formId).get(0));
        // 送信前にエラーをリセット
        _error.reset()
        // 送信
        _ajax.file(action, datas, function (results) {
            // 完了メッセージをセットする
            _complete.set(results);
            // モーダルを閉じる
            _modal.hide(modalId);
            // コンテンツの読込
            load_contents();
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.omitted(xhr, status, errorThrown);
        });
    });
}
